import { render, staticRenderFns } from "./MobileProfile.vue?vue&type=template&id=2260603e&"
import script from "./MobileProfile.vue?vue&type=script&lang=js&"
export * from "./MobileProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports